import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { handleOnChangeIsEdit } from '../../utils/widget'
import ScrutinizeMethodWidget from '../../widgets/scrutinizeMethod/ScrutinizeMethodWidget'
import { getScrutinizeSchemaMulti } from '../../redux/actions/scrutinize'
import { isNewMultiReveiw } from '../../utils/ValidatorUtils'

export default function MeetingSummaryMulti() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [projectIdList, setProjectIdList] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = { groupId: projectId }

      let response = await getScrutinizeSchemaMulti(request)
      console.log('response', JSON.stringify(response))

      if (response?.header) {
        response.header = 'ผลการประชุม'
      }

      if (response?.forms?.scrutinizeMethod?.header) {
        response.forms.scrutinizeMethod.header = 'ผลการประชุม'
        response.forms.scrutinizeMethod.buttonText = 'ผลการประชุม'
      }

      let idList = sessionStorage.getItem('mutiReview')
      // response?.forms?.scrutinizeMethod
      setProjectIdList(idList?.split(','))
      setSchema(response)
      setIsEditWidget({
        scrutinizeMethod: isNewMultiReveiw(projectId),
      })
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {schema?.forms?.scrutinizeMethod && (
        <>
          <ScrutinizeMethodWidget
            showCommandButton={!schema.forms.scrutinizeMethod.disabled}
            schema={schema.forms.scrutinizeMethod}
            isEdit={isEditWidget.scrutinizeMethod}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('scrutinizeMethod', _isEdit, setIsEditWidget)
            }
            projectIdList={projectIdList}
            //isSingle={true}
            isMeetingResult={true}
          />
          <br />
        </>
      )}
    </SidebarProposal>
  )
}
